import React from 'react';
import styled from 'styled-components';

import useFooterMenus from '../../hooks/parameter/useFooterMenus';
import useConfigs from '../../hooks/useConfigs';
import useThemes from '../../hooks/useThemes';

export const Peticiones = () => {
  const { fontSizeMultiplier } = useConfigs();
  const { pqrInfo } = useFooterMenus();
  const { colorSecundario, colorCuarto, backgroundCuarto } = useThemes();

  return (
    <Container
      fontsizemultiplier={fontSizeMultiplier}
      background={backgroundCuarto}
      color={colorSecundario}
      colortipografia={colorCuarto}
    >
      <h2> Peticiones </h2>
      <p className='text-bold'>{pqrInfo?.texto}</p>
      <p className='info'>{pqrInfo?.email}</p>
    </Container>
  );
};

// ##### Estilos #####
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50vw;
  margin-bottom: 3rem;
  padding: 2rem 3rem;
  border-radius: 3rem;
  background-color: ${(props) => props.background};

  h2 {
    font-size: ${(props) => 55 * props.fontsizemultiplier};
    font-weight: 900;
    color: ${(props) => props.color};
    text-align: center;
  }

  .text-bold {
    font-size: ${(props) => 20 * props.fontsizemultiplier};
    color: ${(props) => props.colortipografia};
    font-weight: 700;
    text-align: center;
  }

  .info {
    font-size: ${(props) => 20 * props.fontsizemultiplier};
    color: ${(props) => props.colortipografia};
    text-align: center;
  }

  @media (max-width: 1023px) {
    width: 90vw;
  }
`;
